import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import {
  Heading,
  TabsProvider,
  Tabs,
  Tab,
  IconBookmark,
  IconPositive,
  Stack,
  PageBlock,
  TabPanels,
  TabPanel,
} from 'braid-design-system';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { APPLIED, APPLIED_ROUTE, SAVED, SAVED_ROUTE } from 'src/const/app';
import { useRouteParams } from 'src/hooks/useRouteParams';

import translations from './MyActivityLayout.vocab';

const MyActivityLayoutComponent = () => {
  const { t } = useTranslations(translations);
  const location = useLocation();
  const navigate = useNavigate();
  const type = location.pathname.includes(APPLIED_ROUTE) ? APPLIED : SAVED;
  const savedRoute = useMelwaysLink(SAVED_ROUTE);
  const appliedRoute = useMelwaysLink(APPLIED_ROUTE);
  const { getRouteParams, setRouteParams } = useRouteParams();

  const handleOnChange = () => {
    const currentRoute = type === APPLIED ? appliedRoute : savedRoute;
    const nextRoute = type === APPLIED ? savedRoute : appliedRoute;

    setRouteParams(currentRoute);
    navigate({
      pathname: nextRoute,
      search: getRouteParams(nextRoute),
    });
  };

  return (
    <PageBlock width="medium">
      <TabsProvider
        id="tabs-saved-applied"
        selectedItem={type}
        onChange={handleOnChange}
      >
        <Stack space={{ mobile: 'large', tablet: 'xlarge' }}>
          <Heading level="2">{t('Activity')}</Heading>
          <Stack space="large">
            <Tabs label="activity" divider="none">
              <Tab
                item={SAVED}
                icon={<IconBookmark />}
                data={{ automation: 'tab-saved' }}
              >
                {t('Saved')}
              </Tab>
              <Tab
                item={APPLIED}
                icon={<IconPositive />}
                data={{ automation: 'tab-applied' }}
              >
                {t('Applied')}
              </Tab>
            </Tabs>

            <TabPanels>
              <TabPanel>{type === SAVED ? <Outlet /> : null}</TabPanel>
              <TabPanel>{type === APPLIED ? <Outlet /> : null}</TabPanel>
            </TabPanels>
          </Stack>
        </Stack>
      </TabsProvider>
    </PageBlock>
  );
};

export const MyActivityLayout = MyActivityLayoutComponent;
